import React from 'react';
import { map } from 'lodash';
import { styled } from '@kufox/mui/emotion';
import { useTranslation } from '@tools/i18n';
import Dialog from '@kufox/mui/Dialog';
import useTheme from '@kufox/mui/hooks/useTheme';
import { kcsensorsClick } from '../../common/tools';

const EmailContent = styled.div``;

const EmailContentTitle = styled.div``;

const PhoneContent = styled.div``;

const PhoneContentTitle = styled.div``;

const ContentList = styled.ul`
  margin: 0;
  padding: 0;
`;

const ContentListItem = styled.li`
  list-style: none;
`;

const SendButton = styled.span`
  font-size: ${(props) => props.theme.fonts.size.lg.fontSize};
  line-height: 24px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary};
  text-decoration: underline;
  &:hover {
    opacity: 0.8;
  }
`;

const EmailCheckListFunc = (email, t) => [
  t('newsignup.email.try1'),
  t('newsignup.email.try2', { email }),
  t('newsignup.email.try3', { minute: 10 }),
];

const BasicPhoneCheckFunc = (phone, t) => [
  t('newsignup.phone.try1'),
  t('newsignup.phone.try2'),
  t('newsignup.phone.try3', { phone }),
  t('newsignup.phone.try4', { minute: 10 }),
];

const PhoneCheckListFunc = (options = {}) => {
  const { phone, isSupportVoice, onSend, t, theme } = options;
  const concatArr = isSupportVoice
    ? [
        <SendButton
          onClick={onSend}
          theme={theme}
          dangerouslySetInnerHTML={{ __html: t('newsignup.phone.try5') }}
        />,
      ]
    : [];
  return BasicPhoneCheckFunc(phone, t).concat(concatArr);
};

/**
 * @param    {Boolean}   open    弹窗打开/关闭
 * @param    {Function}  onSend   发送语音验证
 * @param    {Boolean}   isSupportVoice   是否支持语音验证
 * @param    {Function}  onClose 关闭弹窗
 * @param    {String}    phone 手机号
 * @param    {String}    email 邮箱
 */
const DidNotReceiveCode = ({
  open = false,
  isSupportVoice = false,
  onSend = () => {},
  onClose = () => {},
  phone = '',
  email = '',
}) => {
  const theme = useTheme();
  // 组装需要的数据
  const type = phone ? 'phone' : 'email';
  const { t } = useTranslation('entrance');

  const basicObject = {
    onOk: () => {
      const newWindow = window.open('/support');
      newWindow.opener = null;
      kcsensorsClick(['noCodePopUp', '3']);
    },
    onCancel: () => {
      typeof onClose === 'function' && onClose();
      kcsensorsClick(['noCodePopUp', '2']);
    },
    title: type === 'email' ? t('newsignup.email.ask') : t('newsignup.phone.ask'),
    okText: t('newsignup.solve.fail'),
    cancelText: t('newsignup.solved'),
  };

  const handleSend = () => {
    kcsensorsClick(['noCodePopUp', '4']);
    typeof onClose === 'function' && onClose();
    typeof onSend === 'function' && onSend();
  };

  const EmailCheckList = EmailCheckListFunc(email, t);
  const PhoneCheckList = PhoneCheckListFunc({
    phone,
    isSupportVoice,
    onSend: handleSend,
    t,
    theme,
  });

  return (
    <>
      <Dialog maskClosable open={open} {...basicObject}>
        {type === 'email' ? (
          <EmailContent>
            <EmailContentTitle>
              {t('newsignup.email.try')}
              {map(EmailCheckList, (item, index) => (
                <ContentListItem key={index}>{item}</ContentListItem>
              ))}
            </EmailContentTitle>
          </EmailContent>
        ) : (
          <PhoneContent>
            <PhoneContentTitle>{t('newsignup.phone.try')}</PhoneContentTitle>
            <ContentList>
              {map(PhoneCheckList, (item, index) => (
                <ContentListItem key={index}>{item}</ContentListItem>
              ))}
            </ContentList>
          </PhoneContent>
        )}
      </Dialog>
    </>
  );
};

export default DidNotReceiveCode;
